import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import category from '~/store/modules/category';
import { extractCategoryHash, extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import CategorySeo from '~/components/functional/Seo/CategorySeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryJsonld from '~/components/functional/JsonLD/CategoryJsonld.vue';
import CategoryCatalog from '~/components/organisms/Category/CategoryCatalog.vue';
import CategoryInformationalContent from '~/components/organisms/Category/CategoryInformationalContent.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
import CommercialRibbon from '~/components/atoms/Global/CommercialRibbon.vue';
export default {
  validate: function validate(_ref) {
    var alias = _ref.params.alias;
    return alias && extractCategoryHash(alias);
  },
  components: {
    MdmBreadcrumb: MdmBreadcrumb,
    CategorySeo: CategorySeo,
    CategoryTcVars: CategoryTcVars,
    CategoryJsonld: CategoryJsonld,
    CategoryCatalog: CategoryCatalog,
    CategoryInformationalContent: CategoryInformationalContent,
    CategoryLoading: CategoryLoading,
    CategoryTemplate: CategoryTemplate,
    Empty: Empty,
    CommercialRibbon: CommercialRibbon,
    RatingJsonLd: RatingJsonLd
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    };
  },
  fetch: function () {
    var _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref2) {
      var alias, query, store, error;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              alias = _ref2.params.alias, query = _ref2.query, store = _ref2.store, error = _ref2.error;
              registerStoreModule(store, 'category/', category);
              registerStoreModule(store, 'pageActions/', pageActions);

              if (!process.server) {
                _context.next = 17;
                break;
              }

              store.commit('pageActions/SET_DEFAULT_FILTERBY', extractCategoryFilterByFromQuery(query));
              store.commit('pageActions/SET_DEFAULT_SORTBY', extractCategorySortByFromQuery(query));
              store.commit('pageActions/SET_DEFAULT_ORDERBY', extractCategoryOrderByFromQuery(query));
              store.commit('pageActions/SET_PREVIOUS_PAGE', extractCategoryPreviousPageFromQuery(query));
              store.commit('pageActions/SET_NEXT_PAGE', extractCategoryNextPageFromQuery(query));
              _context.prev = 9;
              _context.next = 12;
              return store.dispatch('category/fetchContent', {
                alias: alias,
                query: query
              });

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](9);
              error({
                statusCode: 404,
                message: 'Not Found'
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 14]]);
    }));

    function fetch(_x) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }(),
  asyncData: function asyncData() {
    return {
      serverFetch: process.server
    };
  },
  data: function data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchCategoryQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'category/description',
    products: 'category/products',
    productsCount: 'category/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  }), {
    categoryQuery: function categoryQuery() {
      return _objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy), {
        sort: this.sortBy,
        order: this.orderBy
      });
    },
    selectedFilters: function selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, this.description.slug, this.description.hash));
    },
    breadcrumb: function breadcrumb() {
      var _this = this;

      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(function (entry) {
        return {
          label: entry.title,
          url: entry.slug ? "".concat(_this.baseURL).concat(_this.buildCategoryUrl(_this.locale, entry.slug, entry.hash)) : "/".concat(_this.locale.market, "/").concat(_this.locale.language)
        };
      });
    },
    pageTitle: function pageTitle() {
      return this.description.seo.meta_title || this.description.name || '';
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "category";'
      };
      return luxConfig;
    },
    title: function title() {
      return this.description.title || '';
    },
    categoryImage: function categoryImage() {
      return this.products && this.products[0] && this.products[0].images && this.products[0].images[0] ? this.products[0].images[0].src : null;
    }
  }),
  created: function created() {
    var _this2 = this;

    registerStoreModule(this.$store, 'category/', category, true);
    registerStoreModule(this.$store, 'pageActions/', pageActions, true);

    if (process.client && !this.serverFetch) {
      var _this$$route = this.$route,
          alias = _this$$route.params.alias,
          query = _this$$route.query;
      var args = {
        alias: alias,
        query: query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetPagination();
      this.resetFilters();
      this.resetCategory();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchCategory(args).then(function () {
          _this2.loadingProducts = false;

          _this2.createEbRecord();

          _this2.scrollBackToProduct(localStorage.getItem('currentProduct'));

          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.serverFetch) {
      this.fetchProducts();
    }

    this.unwatchCategoryQuery = this.$watch('categoryQuery',
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(oldVal, newVal) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (shallowEqualObjects(oldVal, newVal)) {
                  _context2.next = 6;
                  break;
                }

                _this3.loadingProducts = true;
                _context2.next = 4;
                return _this3.handleWatcher(_this3.fetchCategory, 1);

              case 4:
                _this3.resetPagination();

                _this3.loadingProducts = false;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.unwatchNextPage = this.$watch('nextPage',
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var predicate;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

              if (predicate) {
                _context3.next = 6;
                break;
              }

              _this3.loadingNextPage = true;
              _context3.next = 5;
              return _this3.handleWatcher(_this3.appendProducts, _this3.nextPage);

            case 5:
              _this3.loadingNextPage = false;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    this.unwatchPreviousPage = this.$watch('previousPage',
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4() {
      var predicate;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

              if (predicate) {
                _context4.next = 6;
                break;
              }

              _this3.loadingPreviousPage = true;
              _context4.next = 5;
              return _this3.handleWatcher(_this3.prependProducts, _this3.previousPage);

            case 5:
              _this3.loadingPreviousPage = false;

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatchCategoryQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },
  methods: _objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetCategory: 'category/RESET_CATEGORY'
  }), mapActions({
    fetchCategory: 'category/fetchContent',
    appendProducts: 'category/appendProducts',
    prependProducts: 'category/prependProducts'
  }), {
    createEbRecord: function createEbRecord() {
      if (this.description) {
        var earlybirdsId = this.description.earlybirdsWidgets ? this.description.earlybirdsWidgets.id : null;
        window.ebRecoIds = [earlybirdsId];
      }
    },
    fetchProducts: function fetchProducts() {
      var _this4 = this;

      var args = {
        alias: this.$route.params.alias,
        query: _objectSpread({}, this.categoryQuery, {
          page: this.nextPage
        }),
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.fetchCategory(args).then(function () {
        _this4.loadingProducts = false;

        _this4.createEbRecord();
      });
    },
    handleWatcher: function () {
      var _handleWatcher = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(handler, page) {
        var alias, query, profileId;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                alias = this.$route.params.alias;
                query = _objectSpread({}, this.categoryQuery, {
                  page: page
                });
                profileId = this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '';
                _context5.prev = 3;
                _context5.next = 6;
                return handler({
                  alias: alias,
                  query: query,
                  profileId: profileId
                });

              case 6:
                this.$router.push({
                  query: pickBy(query, function (e) {
                    return !isNil(e);
                  })
                });
                this.$root.$emit('reset-tcvars');
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](3);
                if (this.$sentry) this.$sentry.captureException(_context5.t0);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 10]]);
      }));

      function handleWatcher(_x4, _x5) {
        return _handleWatcher.apply(this, arguments);
      }

      return handleWatcher;
    }(),
    scrollBackToProduct: function scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(function () {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }
  }),
  head: function head() {
    return {
      script: [this.speedcurveConfig]
    };
  }
};